import { useState, useEffect, Fragment } from "react";
import { Env } from "../../enviroment/environment";
import clientmanagmentObj from "../../services/client-managment.service";
import BoLoader from "../../helpers/BoLoader";
import RefreshToken from "../../helpers/RefreshToken";
import { Link } from "react-router-dom";
import ModelPopup from "../../helpers/ModelPopup";
import { useDispatch, useSelector } from "react-redux";
import { haspermissions } from "../permissions/PermissionTypes";
import SearchGridRunningBalance from "./SearchGridRunningBalance";
const API_URL = Env.ClientAdmin;

const RunningBalances = () => {
    const { user: currentUser } = useSelector((state) => state.auth);
    const [confirmmodalShow, setCnfrmModalShow] = useState(false);
    const [calledfrom, setCalledfrom] = useState(false);
    const [updatefeeval, setupdatefeeval] = useState({});
    const [Content, setContent] = useState();
    const [DataSuccessful, setDataSuccessful] = useState(true);
    const [boloader, setBoLoader] = useState(false);
    const [donutChart, setDonutChart] = useState();
    const [modalsuccessfullShow, setModalsuccessfullShow] = useState(false);
    if (currentUser) {
        haspermissions.CreateClient =
            currentUser?.user?.Permissions?.includes("Create Client");
        haspermissions.LedgerTransfer =
            currentUser?.user?.Permissions?.includes("Ledger Transfer");
    }

    useEffect(() => {
        setDataSuccessful(true);
    }, []);

    const goToClients = () => {
        setDataSuccessful(true);
    };
    const addClientFeeHandler = (callfrom) => {
        setCalledfrom(callfrom)
        setCnfrmModalShow(true);
    }
    return (
        <div className="col-xl-9 col-lg-12 bo-main-content">
            <BoLoader loading={boloader} />
            <Fragment>
                {
                    DataSuccessful && (
                        <SearchGridRunningBalance
                            methodname="getclients"
                            placeholdervalue="Search transactions"
                            headersdata={[
                                "DATE",
                                "TRANSACTION TYPE",
                                "STATUS",
                                "TOKEN ID",
                                "AMOUNT",
                                "RUNNING BALANCE",
                                "CLIENT",
                            ]}
                            apiurl={API_URL}
                            screenname="clients"
                            createclientpermission={haspermissions.CreateClient}
                            updateFee={(val) => addClientFeeHandler(val)}
                            updatevalues={(val) => setupdatefeeval(val)}
                            DataSuccessful={DataSuccessful}

                        />
                    )
                }
            </Fragment>

           
        </div>
    );
};

export default RunningBalances;
